// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import React from 'react';
import { Box, Typography } from '../../../lib/base';
// import type { Theme } from '../../../theme/Theme';

export default function EmptyContainer({
  title,
  description,
  height,
}: { title: string; description: string; height?: string }) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: height ?? '50vh',
        p: 4,
        // backgroundColor: (t: Theme) => t.custom.colors.common.oddRow,
      }}
    >
      <Box sx={{ maxWidth: '600px', textAlign: 'center' }}>
        <Typography sx={{ mb: 1 }} variant="h4">
          {title}
        </Typography>
        <Typography variant="body1">{description}</Typography>
      </Box>
    </Box>
  );
}
